import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {StashBonusBunch} from "./StashBonusBunch";

export class StashBonusBunchGroup extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(StashBonusBunchGroup, v) : SKIP;
            },
            (v) => {
                return deserialize(StashBonusBunchGroup, v);
            }
        );
    }

    constructor() {
        super();
        this._items = [];
    }

    get items() {
        return this._items;
    }

    set items(value) {
        this._items = value;
    }

    get count(){
        return !this.items ? 0 : this.items.length;
    }

    valid() {

        if (this.items && this.items.some(v => !v || !v.valid() || v.empty())) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.items || this.items.length === 0;
    }

    copy() {
        return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new StashBonusBunchGroup());
        } else if (target instanceof StashBonusBunchGroup) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(StashBonusBunchGroup, {
    _items: alias("items", list(StashBonusBunch.schema()))
})
